import React, {useContext} from 'react'
import styled from 'styled-components'
import {AccordionContext} from './AccordionContext'
import Icons from '../Icons'

const AccordionPanel = ({label, children}) => {
  const {active, onPanelChange} = useContext(AccordionContext)
  return (
    <AccordionPanelContainer active={active} data-testid="accordion-container">
      <LabelContainer>
        <StyledLabel onClick={onPanelChange}>
          <div>{label}</div>
          <Icons icon={active ? 'UP_ARROW' : 'DOWN_ARROW'} color="#3395FE" />
        </StyledLabel>
      </LabelContainer>
      <ContentContainer active={active}>{active && children}</ContentContainer>
    </AccordionPanelContainer>
  )
}

const AccordionPanelContainer = styled.div`
  max-height: ${props => (props.active ? '100%' : '55px')};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  border-bottom: 1px solid #f3f5fb;
`

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px 0 16px;
  box-sizing: border-box;
  height: 55px;
  border-radius: 6px;
  margin-top: 2px;
`

const StyledLabel = styled.div`
  flex: 1 0 auto;
  height: 36px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
`

const ContentContainer = styled.div`
  display: ${props => (props.active ? 'block' : 'none')};
  height: 100%;
  overflow-y: auto;
  box-sizing: border-box;
`

export default AccordionPanel
